import Colors from '@figma/panda/Colors'
import { Box, Button, Stack, styled, Typography } from '@mui/material'
import { useState } from 'react'
import type { Feature } from '../types'
import { FeatureDialog } from './FeatureDialog'
import { FeatureList } from './FeatureList'

export const Features = ({ localFeatures, allFeatures, updateLocalFeatures }) => {
  const [isAddFeatureDialogOpen, setIsAddFeatureDialogOpen] = useState(false)

  const handleAddFeature = (feature: Feature) => {
    updateLocalFeatures([...localFeatures, feature])
    setIsAddFeatureDialogOpen(false)
  }

  const handleRemoveFeature = (featureId: string) => {
    updateLocalFeatures(localFeatures.filter((f) => f.id !== featureId))
  }

  return (
    <>
      <Stack width="100%" spacing="24px" sx={{ pt: '24px' }}>
        <StyledFeaturesContainer>
          <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" sx={{ pb: '24px' }}>
            <Typography variant="h6">Features</Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setIsAddFeatureDialogOpen(true)
              }}
            >
              Add feature
            </Button>
          </Stack>

          <FeatureList localFeatures={localFeatures} handleRemoveFeature={handleRemoveFeature} />
        </StyledFeaturesContainer>
      </Stack>

      <FeatureDialog
        isOpen={isAddFeatureDialogOpen}
        onClose={() => {
          setIsAddFeatureDialogOpen(false)
        }}
        onSave={handleAddFeature}
        availableFeatures={allFeatures}
        excludedFeatures={localFeatures}
      />
    </>
  )
}

const StyledFeaturesContainer = styled(Box)`
  width: 50%;
  border: 1px solid ${Colors.base300};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
`
